const autoNgTemplateLoaderTemplate1 = require('./resourcePoolsDatatable.html');

angular.module('shbdeployer.kubernetes').component('kubernetesResourcePoolsDatatable', {
  templateUrl: autoNgTemplateLoaderTemplate1,
  controller: 'KubernetesResourcePoolsDatatableController',
  bindings: {
    titleText: '@',
    titleIcon: '@',
    dataset: '<',
    tableKey: '@',
    orderBy: '@',
    reverseOrder: '<',
    removeAction: '<',
    refreshCallback: '<',
    endpoint: '<',
  },
});
